import React from 'react';
import Link from 'gatsby-link'
import styles from './DestinationCards.module.scss';

const DestinationCards = (props) => (
  <div className={styles.DestinationCards}>
    {props.cards.map((card, i) =>
      <div className={styles.Destination} key={i}>
        <a className={styles.anchor} id={card.destinationName}></a>
        <div className={styles.Destination__Image} style={{backgroundImage: 'url("' + card.featuredImage.file.url + '")'}}>
          <h2>{card.destinationName}</h2>
          <Link className="hoverlink" to={card.link.link}>{card.link.text}</Link>
        </div>
        <div className={styles.Destination__Details}>
          {card.destinationDetails.map((detail, iterator) =>
            <div key={iterator} className="destination-card">
              <h3 className="h3">{detail.title}</h3>
              <p>{detail.text.text}</p>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
)

export default DestinationCards;



// WEBPACK FOOTER //
// ./src/components/ProgramOverview/DestinationCards/index.js